import { orderBy } from '@progress/kendo-data-query';
import React, { useState, useEffect } from 'react';
import calculateSize from 'calculate-size';
import styles from './DeleteObjectLogTable.module.scss';

import EditTableIcon from '../../../fsa-style/img/EditTableIcon.svg';
import searchImg from '../../../fsa-style/img/searchImg.svg';
import { Grid, GridColumn as Column, GridNoRecords, GridColumnMenuCheckboxFilter } from '@progress/kendo-react-grid';
import moment from 'moment';

const headerStyle = (column) => {
  return (
    <div className={styles.tableHeaderStyle}>
      <div className={styles.tableHeaderTitle} style={{ cursor: 'default' }}>
        {column.title}
      </div>
    </div>
  );
};

export const calculateWidth = (data, field, columnName) => {
  let maxWidth = 0;
  const size = calculateSize(columnName.replaceAll('_', ' '), {
    font: 'Arial',
    fontSize: '26px',
  });
  maxWidth = size.width;
  data.forEach((item) => {
    const contentSize = calculateSize(item[field], {
      font: 'Arial',
      fontSize: '24px',
    });
    if (contentSize.width > maxWidth) {
      maxWidth = contentSize.width;
      if (maxWidth > 500) maxWidth = 500;
    }
  });

  return maxWidth;
};

export default function DeleteObjectLogTable(props) {
  const { data = [], fields, total = data.length, page, pageSize, onPageChange } = props;
  const [sort, setSort] = React.useState([]);
  const [tableData, setTableData] = useState([]);
  // const [selectAllChecked, setSelectAllChecked] = useState(false);

  // Filter data based on the search keyword
  // const filteredData = data.filter((item) => {
  //   const buowNameLowerCase = item.buowName.toLowerCase();
  //   const searchKeywordLowerCase = props.searchKeyword.toLowerCase();
  //   return buowNameLowerCase.includes(searchKeywordLowerCase);
  // });

  useEffect(() => {
    fields.forEach((column) => {
      return (column.sortType = ''), { ...column }; //to remove ASC/DESC arrow
    });
  }, []);

  const onSelectSort = (column) => {
    return (
      <div className={styles.tableHeaderStyle} onClick={() => onSortData(column)}>
        <div className={styles.tableHeaderTitle}>
          <div>{column.title}</div>
          {column.showMenuIcon && <div className="header-sort-icon">{column.sortType === '' ? '' : column.sortType === 'ASC' ? '⬆' : '⬇'}</div>}
        </div>
      </div>
    );
  };
  const onSortData = (column) => {
    fields.forEach((obj) => {
      if (obj.field === column.field) {
        if (obj.sortType === '') {
          obj.sortType = 'ASC';
          props.onSortData(column);
        } else if (obj.sortType === 'ASC') {
          obj.sortType = 'DESC';
          props.onSortData(column);
        } else {
          obj.sortType = '';
          props.onRemoveSort();
        }
      } else {
        obj.sortType = '';
      }
    });
    // onSelectSort(column);
  };

  useEffect(() => {
    if (page === 0) {
      const initialData = data.slice(0, pageSize).map((obj, idx) => ({
        ...obj,
        checked: false,
        editIcon: searchImg,
      }));
      setTableData(initialData);
    } else {
      const initialData = data?.map((obj, idx) => ({
        ...obj,
        checked: false,
        editIcon: searchImg,
      }));
      setTableData(initialData);
    }
  }, [data, page, pageSize]);

  const ColumnMenuCheckboxFilter = (props) => {
    return (
      <div>
        <GridColumnMenuCheckboxFilter {...props} data={data} expanded={true} />
      </div>
    );
  };

  return (
    <>
      <Grid
        {...props}
        // total={total}
        data={orderBy(tableData, sort)}
        page={page}
        pageSize={pageSize}
        skip={page * pageSize}
        pageable={{
          buttonCount: 5,
          info: true,
          type: 'numeric',
          pageSizes: [5, 10, 15, 20, 25],
          previousNext: true,
        }}
        onPageChange={onPageChange}
        sortable={true}
        sort={sort}
        total={props.totalHits}
        onSortChange={(e) => {
          setSort(e.sort);
        }}
      >
        <GridNoRecords>No results</GridNoRecords>

        {data &&
          fields?.map((column, index) => {
            return (
              <Column
                // headerCell={headerStyle}
                headerCell={() => onSelectSort(column)}
                field={column.field}
                title={column.title}
                key={index}
                cell={
                  column.field === 'modification_date' || column.field === 'statusstartdate'
                    ? ({ dataItem }) => (
                        <td>
                          <FetchedDateDisplay fetchedDate={dataItem[column.field]} fieldName={column.field} />
                        </td>
                      )
                    : column.field === 'term'
                    ? ({ dataItem }) => <td>{dataItem.term === true ? 'Yes' : dataItem.term === false ? 'No' : ''}</td>
                    : column.cell
                }
                width={data !== undefined && column.field === 'term' ? 130 : 280}
                filter={column.filter}
                columnMenu={column.showMenuIcon ? ColumnMenuCheckboxFilter : undefined}
              />
            );
          })}
        <Column
          headerCell={headerStyle}
          field="edit"
          cell={({ dataItem }) => (
            <td>
              <div className="actionColumn">
                <img src={dataItem.editIcon} style={{ cursor: 'pointer' }} onClick={() => props.EditRowDataFunc(dataItem)} alt="editIcon"></img>
              </div>
            </td>
          )}
          title="View"
          width={100}
          filterable={false}
        />
      </Grid>
    </>
  );
}
// const FetchedDateDisplay = ({ fetchedDate }) => {
//   const parsedDate = moment(fetchedDate).format('M-DD-YYYY h:mm:ss A');
//   // const formattedDate = parsedDate;
//   return <>{parsedDate}</>;
// };
const FetchedDateDisplay = ({ fetchedDate, fieldName }) => {
  if (fetchedDate !== null) {
    if (fieldName === 'modification_date') {
      let utcObj = moment.utc(fetchedDate).toDate();
      const parsedDate = moment(utcObj).local().format('MM-DD-YYYY  hh:mm:ss A');
      // const formattedDate = parsedDate;
      return <>{parsedDate}</>;
    } else {
      let utcObj = moment.utc(fetchedDate).toDate();
      const parsedDate = moment(utcObj).local().format('MM-DD-YYYY');
      // const formattedDate = parsedDate;
      return <>{parsedDate}</>;
    }
  } else return <>-</>;
};
